module.exports = __webpack_public_path__ + "fa97bd560b532d8bc0b651faa019fb67.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Work_Sans/WorkSans-Light.woff2
// module id = 1812
// module chunks = 1